import { initialState } from "./../initialState";
import * as AdditionalActionActions from "./additionalActionActions";

export const additionalActionReducer = (state = initialState.additionalActions, action) => {
    switch (action.type) {
        case AdditionalActionActions.REQUEST_ADDITIONAL_ACTION:
            return { ...state };

        case AdditionalActionActions.REQUEST_ADDITIONAL_ACTION_SUCCEEDED:
            return {
                ...state,
                additionalActionStatus: action?.additionalActionStatus?.map((data) => ({ label: data.name_en, value: data.id, data: data })) || [],
            };

        case AdditionalActionActions.REQUEST_ADDITIONAL__ACTION_FAILED:
            return initialState.additionalAction.additionalActionStatus;

        case AdditionalActionActions.SAVE_ADDITIONAL_ACTION_INFO:
            return Object.assign({}, state, {
                additionalActionRequest: action.additionalActionRequest,
            });

        case AdditionalActionActions.SAVE_ADDITIONAL_ACTION_INFO_SUCCEEDED:
            return Object.assign({}, state, {
                additionalActionResponse: action.additionalActionResponse,
            });
        case AdditionalActionActions.SAVE_ADDITIONAL_ACTION_INFO_FAILED:
            return initialState.additionalAction.additionalActionResponse;

        default:
            return state;
    }
};
